<app-sidebar-menu [toggleSub$]="toggleSub"></app-sidebar-menu>
<aside id="viho-aside" class="viho-aside active-viho-aside">
    <app-user-info-viho [profile]="privateProfile"  *ngIf="auth.loggedIn$ | async"></app-user-info-viho>
    <nav>
        <div class="main-navbar">
            <div id="mainnav" >
                <ul class="nav-menu custom-scrollbar">
                    <!-- [ngClass]="{active: item.active}" -->
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.website">
                        <a  routerLink="/webpage" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{'WEBSITE' | translate }}">
                            <i class="bx bx-list-check"></i>
                            <span  class="ng-star-inserted"> {{'WEBSITE' | translate }}</span>
                        </a>
                    </li>
                    <li class="menu-title ng-star-inserted" *ngIf="styleService.appMenu.events" >
                        <a routerLink="/events" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="Events" [class.active]="isEventsActive">
                            <i class="bx bx-calendar"></i>
                            <span  class="ng-star-inserted">Events</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.sessions">
                        <a  routerLink="/sessions" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{'SESSIONS' | translate }}">
                            <i class="bx bx-list-check"></i>
                            <span  class="ng-star-inserted"> {{'SESSIONS' | translate }}</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.results">
                        <a  routerLink="/results" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{'MAIN_TAB_RESULTS' | translate }}">
                            <i class="bx bx-list-ul"></i>
                            <span  class="ng-star-inserted"> {{'MAIN_TAB_RESULTS' | translate }}</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.lineup">
                        <a  routerLink="/lineup" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{'LINEUP_SINGLE' | translate }}">
                            <i class="bx bx-list-check"></i>
                            <span  class="ng-star-inserted"> {{'LINEUP_SINGLE' | translate }}</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.schedule">
                        <a  routerLink="/schedule" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="MatchPlanL">
                            <i class="bx bxs-news"></i>
                            <span  class="ng-star-inserted"> {{'SCHEDULE_SINGLE' | translate }}</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted"*ngIf="styleService.appMenu.news">
                        <a  routerLink="/news" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{ 'MAIN_TAB_NEWS' | translate }}">
                            <i class="bx bx-news"></i>
                            <span  class="ng-star-inserted"> {{ 'MAIN_TAB_NEWS' | translate }}</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.gallery">
                        <a  routerLink="/gallery" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{ 'GALLERY_TAB' | translate }}">
                            <i class="bx bx-photo-album"></i>
                            <span  class="ng-star-inserted">  {{ 'GALLERY_TAB' | translate }}</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted"  *ngIf="styleService.appMenu.products">
                        <a  routerLink="/shop" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="Shop">
                            <i class="bx bx-shopping-bag"></i>
                            <span  class="ng-star-inserted">  Shop</span>
                        </a>
                    </li>
                    <li class="sidebar-main-title ng-star-inserted" *ngIf="styleService.appMenu.contact">
                        <a  routerLink="/contact" routerLinkActive="active" class="nav-link menu-title ng-star-inserted" title="{{ 'EVENT_DETAILS_TAB_CONTACT' | translate }}">
                            <i class="bx bxs-contact"></i>
                            <span  class="ng-star-inserted">  {{ 'EVENT_DETAILS_TAB_CONTACT' | translate }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</aside>

<div class="main-container"> 
    <div id="main-content" class="main-content padding-340">
        <section class="blog-details-area bg-0f1d22">
            <router-outlet></router-outlet>
        </section>
</div>
